import React from 'react';

import { CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    loader : {
        color : '#FE752F'
    }
}))

export const Loader = function Loader(props){

    const classes = useStyles();

    return(
        <div className="loadingPage" >
          <div className="loadingCircle" >
            <CircularProgress classes={{ colorPrimary : classes.loader }}   />
          </div>
          <span className="loadingText" >Loading Portals...</span>
        </div>
    )

}